<label class="switch_toogle mb-0 d-flex" [ngClass]="switchTopClass" [ngStyle]="{'cursor':onlySelfAccess?'not-allowed':'pointer'}">
    <input type="checkbox" [id]="id" [name]="id" [(ngModel)]="switchStatus" (ngModelChange)="changeStatus.emit(switchStatus)" [disabled]="onlySelfAccess">
    <span [class]="switchClass" class="slider"></span>
</label>
